/**
 * @description 助力
 * @author Kody
 * @date 2019-08-08
 */
import Api from '../../../path';
import { fetchData } from '@umu/umu-fetch';

interface IInput {
    uid: string;
    skey: string;
}
interface IOutput {
    points: number; // 助力后自己获得的影响力点数
}

export const toBoost = (data: IInput): Promise<IResponse<IOutput>> => {
    return fetchData(Api.INFLUENCE_BOOST, data).then((res: IResponse<IOutput>) => {
        return res;
    });
};
